import React from 'react'

import { AnalyticsDataLabel } from '../../../../analyticsModule/components/AnalyticsDataLabel/AnalyticsDataLabel'
import { AnalyticsSocialPlatformLabel } from '../../../../analyticsModule/components/AnalyticsSocialPlatform/AnalyticsSocialPlatformLabel'
import type { AnalyticsSocialPlatformLabelType } from '../../../../analyticsModule/components/AnalyticsSocialPlatform/AnalyticsSocialPlatformLabel.types'
import { useAnalyticsCardBase } from '../../../../hooks/useAnalyticsCardBase'
import type { BarStatsReportCardProps } from '../../AnalyticsDashboard.types'
import { createStatsData } from '../../utils/createStatsData'

const reportId = 'sales_by_source'

type Source = 'traffic_source' | 'social_platform'

type Options = {
  source: Source
}

type SalesBySourceRow = {
  source: string
  total_sales: { value: number; currency: string }
}

const header: Record<Source, string> = {
  traffic_source: 'Sales by traffic source',
  social_platform: 'Sales by social platform',
}

const headerTooltipTitle: Record<Source, string> = {
  traffic_source: 'Sales by traffic source',
  social_platform: 'Sales by social platform',
}

const headerTooltipDescription: Record<Source, string> = {
  traffic_source: 'Breakdown of sales grouped by where visitors came from.',
  social_platform: 'Breakdown of sales grouped by social platform.',
}

export const useSalesBySourceReportCard = ({ source }: Options): BarStatsReportCardProps => {
  const analyticsCardBase = useAnalyticsCardBase({
    reportId,
    filters: { source_dimension: source },
  })

  const data = createStatsData<SalesBySourceRow>({
    rows: analyticsCardBase.reportData?.report?.rows,
    mapFn: (row) => ({
      label:
        source === 'social_platform' ? (
          <AnalyticsSocialPlatformLabel type={row.source as AnalyticsSocialPlatformLabelType} />
        ) : (
          <AnalyticsDataLabel label={row.source} />
        ),
      value: row.total_sales.value,
    }),
  })

  return {
    ...analyticsCardBase,
    type: 'barStats',
    header: {
      label: header[source],
      tooltip: {
        title: headerTooltipTitle[source],
        description: headerTooltipDescription[source],
      },
    },
    data,
  }
}
